import {ChangeDetectionStrategy, Component, HostBinding, inject, input} from '@angular/core';
import {
  HousingOpportunitiesSearchComponent
} from "../housing-opportunities-search/housing-opportunities-search.component";
import {ApartmentService} from "../../services/apartment.service";
import {initialSignupRoute} from "../../pages/signup/specific-signup.routes";
import {FullFooterComponent} from "../full-footer/full-footer.component";
import {TranslocoPipe} from "@jsverse/transloco";
import {TranslateRoutePipe} from "../../translate-route.pipe";
import {TranslateService} from "../../services/translate.service";

@Component({
  selector: 'homey-lotteries-and-footer',
  imports: [
    HousingOpportunitiesSearchComponent,
    FullFooterComponent,
    TranslocoPipe,
    TranslateRoutePipe
  ],
  templateUrl: './lotteries-and-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotteriesAndFooterComponent {
  @HostBinding('class') class = 'flex flex-col pt-16';
  public readonly excludeLotteryId = input<string>();
  public readonly includeBorough = input<string>();
  public readonly defaultSignupRoute = input<string[]>(initialSignupRoute)

  public readonly apartmentService = inject(ApartmentService);
  protected readonly translateService = inject(TranslateService);
}
